var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0234 13.8725V13.0615C26.0234 10.3 28.262 8.06146 31.0234 8.06146H33.5446C36.3061 8.06146 38.5446 10.3 38.5446 13.0615V13.8725",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.502 36.1843V19.163C13.502 16.4016 15.7405 14.163 18.5019 14.163H45.7744C48.5358 14.163 50.7744 16.4016 50.7744 19.163V36.1843C50.7744 38.9457 48.5358 41.1843 45.7744 41.1843H18.502C15.7405 41.1843 13.502 38.9457 13.502 36.1843Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.502 21.4268L28.1604 24.5771C30.9733 25.1816 33.8834 25.1721 36.6922 24.5493L50.7744 21.4268",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1977 21.2544H59.6373M50.9164 35.5702H59.0746M49.5098 40.6228C51.7603 42.1199 56.0927 46.8544 55.4175 53.8158M49.5098 14.7982C51.0101 12.9269 53.8421 8.62281 53.1669 6.3772",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.6374,
    cy: 21.5351,
    rx: 2.8132,
    ry: 2.80702,
    fill: "#BFF32F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.448,
    cy: 4.1316,
    rx: 2.8132,
    ry: 2.80702,
    fill: "#BFF32F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.3259,
    cy: 35.5702,
    rx: 2.8132,
    ry: 2.80702,
    fill: "#BFF32F"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.1364,
    cy: 56.3422,
    rx: 2.8132,
    ry: 2.80702,
    fill: "#BFF32F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0681,
    cy: 54.6579,
    rx: 2.8132,
    ry: 2.80702,
    fill: "#BFF32F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9386 21.2544H4.499M13.2199 35.5702H5.06164M32.0684 41.4649V54.3772M14.6265 40.6228C12.376 42.1199 8.04363 46.8544 8.7188 53.8158M14.6265 14.7982C13.1261 12.9269 10.2942 8.62281 10.9694 6.3772",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.8132,
    cy: 2.80702,
    rx: 2.8132,
    ry: 2.80702,
    transform: "matrix(-1 0 0 1 7.3125 18.7281)",
    fill: "#BFF32F"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.8132,
    cy: 2.80702,
    rx: 2.8132,
    ry: 2.80702,
    transform: "matrix(-1 0 0 1 13.501 1.32458)",
    fill: "#BFF32F"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.8132,
    cy: 2.80702,
    rx: 2.8132,
    ry: 2.80702,
    transform: "matrix(-1 0 0 1 5.62402 32.7632)",
    fill: "#BFF32F"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.8132,
    cy: 2.80702,
    rx: 2.8132,
    ry: 2.80702,
    transform: "matrix(-1 0 0 1 11.8135 53.5352)",
    fill: "#BFF32F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.3b3642f7f2079ddfaff532e07440d1f5.svg";
export { ForwardRef as ReactComponent };